import { toast } from "react-toastify";
import i18n from "../i18n";

const BASE_TOAST_OPTIONS = {
  position: "top-right",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const handledErrors = new WeakSet();

export const MESSAGE_CODES = Object.freeze({
  UNKNOWN_ERROR: "COMMON.UNKNOWN_ERROR",
  WARNING: "COMMON.WARNING",
  INFO: "COMMON.INFO",
  LOGIN_SUCCESS: "AUTH.LOGIN_SUCCESS",
  LOGIN_FAILED: "AUTH.LOGIN_FAILED",
  SSO_LOGIN_FAILED: "AUTH.SSO_LOGIN_FAILED",
  SESSION_EXPIRED: "AUTH.SESSION_EXPIRED",
  SESSION_REPLACED: "AUTH.SESSION_REPLACED",
  LOGOUT_SUCCESS: "AUTH.LOGOUT_SUCCESS",
  PASSWORD_UPDATE_SUCCESS: "AUTH.PASSWORD_UPDATE_SUCCESS",
  REQUIRED_FIELD: "VALIDATION.REQUIRED_FIELD",
  INVALID_VALUE: "VALIDATION.INVALID_VALUE",
  NO_SELECTION: "VALIDATION.NO_SELECTION",
  NO_CHANGES: "VALIDATION.NO_CHANGES",
  FILE_UPLOAD_SUCCESS: "FILE.UPLOAD_SUCCESS",
  FILE_DELETE_SUCCESS: "FILE.DELETE_SUCCESS",
  FILE_REMOVE_PENDING_SAVE: "FILE.REMOVE_PENDING_SAVE",
  FILE_DOWNLOAD_SUCCESS: "FILE.DOWNLOAD_SUCCESS",
  FILE_TYPE_NOT_ALLOWED: "FILE.TYPE_NOT_ALLOWED",
  FILE_SIZE_EXCEEDED: "FILE.SIZE_EXCEEDED",
  FILE_MAX_COUNT_EXCEEDED: "FILE.MAX_COUNT_EXCEEDED",
  FILE_NETWORK_ERROR: "FILE.NETWORK_ERROR",
  ORG_UPDATE_SUCCESS: "ORG.UPDATE_SUCCESS",
  ORG_UPDATE_FAILED: "ORG.UPDATE_FAILED",
  ORG_RESET_SUCCESS: "ORG.RESET_SUCCESS",
  ORG_CREATE_CATEGORY_SUCCESS: "ORG.CREATE_CATEGORY_SUCCESS",
  ORG_UPDATE_CATEGORY_SUCCESS: "ORG.UPDATE_CATEGORY_SUCCESS",
  ORG_DELETE_CATEGORY_SUCCESS: "ORG.DELETE_CATEGORY_SUCCESS",
  ORG_SWITCH_STRUCTURE_SUCCESS: "ORG.SWITCH_STRUCTURE_SUCCESS",
  ORG_CREATE_USER_SUCCESS: "ORG.CREATE_USER_SUCCESS",
  ORG_UPDATE_USER_SUCCESS: "ORG.UPDATE_USER_SUCCESS",
  ORG_DELETE_USER_SUCCESS: "ORG.DELETE_USER_SUCCESS",
  ORG_EMAIL_ALREADY_USED: "ORG.EMAIL_ALREADY_USED",
  ORG_USER_LIMIT_REACHED: "ORG.USER_LIMIT_REACHED",
  BOUNDARY_ORG_SAVE_SUCCESS: "BOUNDARY.ORG_SAVE_SUCCESS",
  BOUNDARY_ORG_DELETE_SUCCESS: "BOUNDARY.ORG_DELETE_SUCCESS",
  BOUNDARY_CRITERIA_SAVE_SUCCESS: "BOUNDARY.CRITERIA_SAVE_SUCCESS",
  BOUNDARY_REPORTING_SAVE_SUCCESS: "BOUNDARY.REPORTING_SAVE_SUCCESS",
  EMISSION_INVENTORY_IMPORT_COMPLETE:
    "EMISSION_INVENTORY.IMPORT_COMPLETE",
  EMISSION_INVENTORY_IMPORT_COMPLETE_WITH_ERRORS:
    "EMISSION_INVENTORY.IMPORT_COMPLETE_WITH_ERRORS",
  EMISSION_INVENTORY_REFRESH_SUCCESS:
    "EMISSION_INVENTORY.REFRESH_SUCCESS",
  EMISSION_INVENTORY_DATE_OUT_OF_PERIOD:
    "EMISSION_INVENTORY.DATE_OUT_OF_PERIOD",
  EMISSION_INVENTORY_EXPORT_SUCCESS:
    "EMISSION_INVENTORY.EXPORT_SUCCESS",
  EMISSION_INVENTORY_EXPORT_NO_DATA:
    "EMISSION_INVENTORY.EXPORT_NO_DATA",
  EMISSION_INVENTORY_ACTIVITY_CREATE_SUCCESS:
    "EMISSION_INVENTORY.ACTIVITY_CREATE_SUCCESS",
  EMISSION_INVENTORY_ACTIVITY_UPDATE_SUCCESS:
    "EMISSION_INVENTORY.ACTIVITY_UPDATE_SUCCESS",
  EMISSION_INVENTORY_ACTIVITY_DELETE_SUCCESS:
    "EMISSION_INVENTORY.ACTIVITY_DELETE_SUCCESS",
  EMISSION_INVENTORY_DATA_UPDATE_SUCCESS:
    "EMISSION_INVENTORY.DATA_UPDATE_SUCCESS",
  EMISSION_INVENTORY_DATA_CREATE_SUCCESS:
    "EMISSION_INVENTORY.DATA_CREATE_SUCCESS",
  EMISSION_INVENTORY_DATA_DELETE_SUCCESS:
    "EMISSION_INVENTORY.DATA_DELETE_SUCCESS",
  EMISSION_INVENTORY_DATA_FILE_DELETE_SUCCESS:
    "EMISSION_INVENTORY.DATA_FILE_DELETE_SUCCESS",
  EMISSION_INVENTORY_DATA_UPLOAD_SUCCESS:
    "EMISSION_INVENTORY.DATA_UPLOAD_SUCCESS",
  EMISSION_INVENTORY_DATA_UPLOAD_FAILED:
    "EMISSION_INVENTORY.DATA_UPLOAD_FAILED",
  EMISSION_INVENTORY_EF_CREATE_SUCCESS:
    "EMISSION_INVENTORY.EF_CREATE_SUCCESS",
  EMISSION_INVENTORY_EF_UPDATE_SUCCESS:
    "EMISSION_INVENTORY.EF_UPDATE_SUCCESS",
  EMISSION_OVERVIEW_DELETE_SUCCESS: "EMISSION_OVERVIEW.DELETE_SUCCESS",
  EMISSION_OVERVIEW_SEND_EMAIL_SUCCESS:
    "EMISSION_OVERVIEW.SEND_EMAIL_SUCCESS",
  EMISSION_OVERVIEW_SEND_EMAIL_FAILED:
    "EMISSION_OVERVIEW.SEND_EMAIL_FAILED",
  DASHBOARD_METRIC_UPDATE_SUCCESS: "DASHBOARD.METRIC_UPDATE_SUCCESS",
  DASHBOARD_METRIC_DELETE_SUCCESS: "DASHBOARD.METRIC_DELETE_SUCCESS",
  DASHBOARD_DECARBONIZATION_UPDATE_SUCCESS:
    "DASHBOARD.DECARBONIZATION_UPDATE_SUCCESS",
  DATA_QUALITY_SAVE_SUCCESS: "DATA_QUALITY.SAVE_SUCCESS",
  UNCERTAINTY_SAVE_SUCCESS: "UNCERTAINTY.SAVE_SUCCESS",
  GHG_PERFORMANCE_SAVE_SUCCESS: "GHG_PERFORMANCE.SAVE_SUCCESS",
  REPORT_DOWNLOAD_SUCCESS: "REPORT.DOWNLOAD_SUCCESS",
  REPORT_NO_DATA: "REPORT.NO_DATA",
  REPORT_DATA_INCOMPLETE: "REPORT.DATA_INCOMPLETE",
  REPORT_CONFIG_BOUNDARY: "REPORT.CONFIG_BOUNDARY",
  REPORT_TIMEOUT: "REPORT.TIMEOUT",
  REPORT_UPDATE_SUCCESS: "REPORT.UPDATE_SUCCESS",
  REPORT_UPLOAD_SUCCESS: "REPORT.UPLOAD_SUCCESS",
  REPORT_DELETE_SUCCESS: "REPORT.DELETE_SUCCESS",
  GHG_PERFORMANCE_DELETE_SUCCESS: "GHG_PERFORMANCE.DELETE_SUCCESS",
  CUSTOM_EF_CREATE_SUCCESS: "CUSTOM_EF.CREATE_SUCCESS",
  CUSTOM_EF_UPDATE_SUCCESS: "CUSTOM_EF.UPDATE_SUCCESS",
  CUSTOM_EF_DELETE_SUCCESS: "CUSTOM_EF.DELETE_SUCCESS",
  CUSTOM_EF_IN_USE: "CUSTOM_EF.IN_USE",
  FEEDBACK_SEND_SUCCESS: "FEEDBACK.SEND_SUCCESS",
  PROFILE_UPDATE_SUCCESS: "PROFILE.UPDATE_SUCCESS",
  TRANSLATION_CREATE_SUCCESS: "TRANSLATION.CREATE_SUCCESS",
  TRANSLATION_UPDATE_SUCCESS: "TRANSLATION.UPDATE_SUCCESS",
  TRANSLATION_ALREADY_EXISTS: "TRANSLATION.ALREADY_EXISTS",
  GUIDANCE_BASIC_INFO_CREATE_SUCCESS: "GUIDANCE.BASIC_INFO_CREATE_SUCCESS",
  GUIDANCE_BASIC_INFO_UPDATE_SUCCESS: "GUIDANCE.BASIC_INFO_UPDATE_SUCCESS",
  GUIDANCE_BOUNDARY_SITE_UPDATE_SUCCESS:
    "GUIDANCE.BOUNDARY_SITE_UPDATE_SUCCESS",
  GUIDANCE_BOUNDARY_SITE_DELETE_SUCCESS:
    "GUIDANCE.BOUNDARY_SITE_DELETE_SUCCESS",
  GUIDANCE_EMISSION_SETTING_UPDATE_SUCCESS:
    "GUIDANCE.EMISSION_SETTING_UPDATE_SUCCESS",
  GUIDANCE_EMISSION_SOURCE_UPDATE_SUCCESS:
    "GUIDANCE.EMISSION_SOURCE_UPDATE_SUCCESS",
  GUIDANCE_EMISSION_SOURCE_DELETE_SUCCESS:
    "GUIDANCE.EMISSION_SOURCE_DELETE_SUCCESS",
  GUIDANCE_ACTIVITY_DATA_UPDATE_SUCCESS:
    "GUIDANCE.ACTIVITY_DATA_UPDATE_SUCCESS",
  GUIDANCE_TESTING_METHOD_UPDATE_SUCCESS:
    "GUIDANCE.TESTING_METHOD_UPDATE_SUCCESS",
  GUIDANCE_UNIT_DEPARTMENT_UPDATE_SUCCESS:
    "GUIDANCE.UNIT_DEPARTMENT_UPDATE_SUCCESS",
  GUIDANCE_UNIT_DEPARTMENT_DELETE_SUCCESS:
    "GUIDANCE.UNIT_DEPARTMENT_DELETE_SUCCESS",
  VERIFICATION_APPLICATION_CREATE_SUCCESS:
    "VERIFICATION.APPLICATION_CREATE_SUCCESS",
  VERIFICATION_FEEDBACK_SUBMIT_SUCCESS:
    "VERIFICATION.FEEDBACK_SUBMIT_SUCCESS",
  VERIFICATION_APPLICATION_APPROVE_SUCCESS:
    "VERIFICATION.APPLICATION_APPROVE_SUCCESS",
  VERIFICATION_APPLICATION_WITHDRAW_SUCCESS:
    "VERIFICATION.APPLICATION_WITHDRAW_SUCCESS",
  VERIFICATION_APPLICATION_FEEDBACK_SUBMIT_SUCCESS:
    "VERIFICATION.APPLICATION_FEEDBACK_SUBMIT_SUCCESS",
  VERIFICATION_CANCEL_SUCCESS: "VERIFICATION.CANCEL_SUCCESS",
  VERIFICATION_COMPLETE_SUCCESS: "VERIFICATION.COMPLETE_SUCCESS",
  VERIFICATION_REJECT_SUCCESS: "VERIFICATION.REJECT_SUCCESS",
  VERIFICATION_DECLARATION_FEEDBACK_SUBMIT_SUCCESS:
    "VERIFICATION.DECLARATION_FEEDBACK_SUBMIT_SUCCESS",
  VERIFICATION_REVISION_REVIEW_SUBMIT_SUCCESS:
    "VERIFICATION.REVISION_REVIEW_SUBMIT_SUCCESS",
});

const API_MESSAGE_CODE_PATTERN = /^[A-Z][A-Z0-9_.]{0,99}$/;

const TOAST_TYPE_CONFIG = Object.freeze({
  error: {
    fallbackCode: MESSAGE_CODES.UNKNOWN_ERROR,
    hardcodedFallback: "Something went wrong. Please try again later.",
  },
  success: {
    fallbackCode: null,
    hardcodedFallback: "Operation completed successfully.",
  },
  warning: {
    fallbackCode: MESSAGE_CODES.WARNING,
    hardcodedFallback: "Please review the information and try again.",
  },
  info: {
    fallbackCode: MESSAGE_CODES.INFO,
    hardcodedFallback: "Please review the latest information.",
  },
});

const isErrorLike = (value) =>
  value instanceof Error ||
  Boolean(value?.response) ||
  Boolean(value?.request) ||
  typeof value?.status === "number";

const translate = (key, ns, i18nOptions, fallback) => {
  if (!key) return fallback;

  const translated = i18n.t(key, {
    ns: ns || "System",
    defaultValue: "",
    ...i18nOptions,
  });

  return translated && translated !== key ? translated : fallback;
};

const normalizeOptions = (options = {}) => {
  if (typeof options === "string") {
    return { i18nKey: options, fallback: options };
  }
  return options || {};
};

const normalizeErrorArguments = (err, options) => {
  if (typeof err === "string" && isErrorLike(options)) {
    return { error: options, options: { fallback: err } };
  }
  return { error: err, options: normalizeOptions(options) };
};

const getAPIData = (error, apiData) =>
  apiData !== undefined ? apiData : error?.response?.data;

const getMessageCodeState = (apiData) => {
  const candidates = [apiData, apiData?.data, apiData?.response?.data];
  const source = candidates.find(
    (candidate) =>
      candidate &&
      typeof candidate === "object" &&
      Object.prototype.hasOwnProperty.call(candidate, "messageCode") &&
      candidate.messageCode !== null &&
      candidate.messageCode !== undefined &&
      candidate.messageCode !== "",
  );

  return {
    hasMessageCode: Boolean(source),
    messageCode: source?.messageCode ?? null,
    messageParams: source?.messageParams ?? source?.params,
  };
};

const resolveCommonMessage = (type, i18nOptions) => {
  const config = TOAST_TYPE_CONFIG[type];
  if (!config.fallbackCode) return config.hardcodedFallback;

  return translate(
    config.fallbackCode,
    "System",
    i18nOptions,
    config.hardcodedFallback,
  );
};

const resolveFrontendMessage = ({
  type,
  i18nKey,
  ns,
  i18nOptions,
  fallback,
}) =>
  translate(
    i18nKey,
    ns,
    i18nOptions,
    i18nKey || fallback || resolveCommonMessage(type, i18nOptions),
  );

const resolveSystemCode = (messageCode, i18nOptions) =>
  translate(messageCode, "System", i18nOptions, messageCode);

const getDefaultAPIScenarioCode = (type) => {
  if (type === "error") return MESSAGE_CODES.UNKNOWN_ERROR;
  if (type === "success") return null;
  return TOAST_TYPE_CONFIG[type].fallbackCode;
};

const resolveAPIMessage = ({
  type,
  apiData,
  i18nOptions,
  scenarioCode,
}) => {
  const { hasMessageCode, messageCode, messageParams } = getMessageCodeState(apiData);
  // Backend parameters are interpolation values, not i18next configuration.
  const translationOptions = {
    ...(messageParams && typeof messageParams === "object" && !Array.isArray(messageParams)
      ? { replace: messageParams }
      : {}),
    ...i18nOptions,
  };

  if (hasMessageCode) {
    if (
      typeof messageCode === "string" &&
      API_MESSAGE_CODE_PATTERN.test(messageCode)
    ) {
      return resolveSystemCode(messageCode, translationOptions);
    }

    if (type === "error") {
      return resolveSystemCode(MESSAGE_CODES.UNKNOWN_ERROR, i18nOptions);
    }
  }

  const fallbackCode = scenarioCode || getDefaultAPIScenarioCode(type);
  return fallbackCode
    ? resolveSystemCode(fallbackCode, i18nOptions)
    : "";
};

export const getSafeErrorMessage = (options = {}) =>
  resolveCommonMessage("error", options.i18nOptions);

export function showErrorToast(options = {}) {
  const opts = normalizeOptions(options);
  const msg = resolveFrontendMessage({
    type: "error",
    i18nKey: opts.i18nKey,
    ns: opts.ns,
    i18nOptions: opts.i18nOptions,
    fallback: opts.fallback,
  });

  toast.error(msg, {
    ...BASE_TOAST_OPTIONS,
    autoClose: 2000,
    ...opts.toastOptions,
  });
  return msg;
}

export function handleAPIError(err, options = {}) {
  const normalized = normalizeErrorArguments(err, options);
  const opts = normalized.options;
  const {
    apiData,
    i18nOptions,
    scenarioCode,
    throwError = true,
    toastOptions,
  } = opts;

  if (
    normalized.error &&
    typeof normalized.error === "object" &&
    handledErrors.has(normalized.error)
  ) {
    if (throwError) throw normalized.error;
    return "";
  }

  const resolvedAPIData = getAPIData(normalized.error, apiData);
  const isFrontendError =
    typeof normalized.error === "string" &&
    typeof options === "string";
  const msg = isFrontendError
    ? resolveFrontendMessage({
        type: "error",
        i18nKey: opts.i18nKey,
        ns: opts.ns,
        i18nOptions,
        fallback: opts.fallback,
      })
    : resolveAPIMessage({
        type: "error",
        apiData: resolvedAPIData,
        i18nOptions,
        scenarioCode,
      });

  toast.error(msg, {
    ...BASE_TOAST_OPTIONS,
    autoClose: 2000,
    ...toastOptions,
  });
  if (normalized.error && typeof normalized.error === "object") {
    handledErrors.add(normalized.error);
  }
  console.error("API request failed", {
    error: normalized.error,
    apiData: resolvedAPIData,
  });

  if (throwError) {
    const errorToThrow =
      normalized.error instanceof Error ? normalized.error : new Error(msg);
    handledErrors.add(errorToThrow);
    throw errorToThrow;
  }
  return msg;
}

export default handleAPIError;

export function showSuccessToast(options = {}) {
  const opts = normalizeOptions(options);
  const {
    apiData,
    i18nKey,
    ns,
    i18nOptions,
    fallback,
    scenarioCode,
    toastOptions,
  } = opts;

  const msg =
    apiData !== undefined || scenarioCode
      ? resolveAPIMessage({
          type: "success",
          apiData,
          i18nOptions,
          scenarioCode,
        })
      : resolveFrontendMessage({
          type: "success",
          i18nKey,
          ns,
          i18nOptions,
          fallback,
        });

  if (!msg) {
    if (process.env.NODE_ENV !== "production") {
      console.error(
        "API success toast requires a backend messageCode or frontend scenarioCode.",
      );
    }
    return "";
  }

  toast.success(msg, {
    ...BASE_TOAST_OPTIONS,
    autoClose: 1000,
    ...toastOptions,
  });
  return msg;
}

export function showWarningToast(options = {}) {
  const opts = normalizeOptions(options);
  const msg =
    opts.apiData !== undefined || opts.scenarioCode
      ? resolveAPIMessage({
          type: "warning",
          apiData: opts.apiData,
          i18nOptions: opts.i18nOptions,
          scenarioCode: opts.scenarioCode,
        })
      : resolveFrontendMessage({
          type: "warning",
          i18nKey: opts.i18nKey,
          ns: opts.ns,
          i18nOptions: opts.i18nOptions,
          fallback: opts.fallback,
        });

  toast.warning(msg, {
    ...BASE_TOAST_OPTIONS,
    autoClose: 2000,
    ...opts.toastOptions,
  });
  return msg;
}

export function showInfoToast(options = {}) {
  const opts = normalizeOptions(options);
  const msg =
    opts.apiData !== undefined || opts.scenarioCode
      ? resolveAPIMessage({
          type: "info",
          apiData: opts.apiData,
          i18nOptions: opts.i18nOptions,
          scenarioCode: opts.scenarioCode,
        })
      : resolveFrontendMessage({
          type: "info",
          i18nKey: opts.i18nKey,
          ns: opts.ns,
          i18nOptions: opts.i18nOptions,
          fallback: opts.fallback,
        });

  toast.info(msg, {
    ...BASE_TOAST_OPTIONS,
    autoClose: 2000,
    ...opts.toastOptions,
  });
  return msg;
}
